import { createSlice } from '@reduxjs/toolkit';
import { API } from 'api';

const initialState = {
	statesWithCites: {},
	cities: [],
};

export const airSlice = createSlice({
	name: 'AirExpensesState',
	initialState,
});

export const getAirExpensesList =
	({ search_type = '', limit = 10, offset = 0, currentPage, ...rest }) =>
	async () => {
		const CREDENTIALS = {
			url: '/search',
			data: {
				search_type,
				limit,
				offset,
				filter_by: { ...rest },
			},
		};

		return API.common(CREDENTIALS).then((response) => ({
			rows: response?.data,
			count: response?.meta?.count,
		}));
	};

export default airSlice.reducer;
